import { Mail, MessageSquareText, Smartphone } from 'lucide-react';
import type { SegmentationChannel } from '@/shared/types/segmentation';
import { SegmentedControl } from '@/shared/ui/segmented-control';
import { Tooltip } from '@/shared/ui/tooltip';
import { SEGMENTATION_CHANNEL_COPY } from '../model/segmentation-channel';

const OPTIONS = [
  { value: 'push' as const, label: SEGMENTATION_CHANNEL_COPY.push.label, icon: Smartphone },
  { value: 'email' as const, label: SEGMENTATION_CHANNEL_COPY.email.label, icon: Mail },
  { value: 'sms' as const, label: SEGMENTATION_CHANNEL_COPY.sms.label, icon: MessageSquareText },
];

interface Props {
  value: SegmentationChannel;
  onChange: (channel: SegmentationChannel) => void;
}

/** Método de disparo = filtro base da segmentação, sempre aplicado (não vira condição do canvas). */
export function SegmentationChannelPicker({ value, onChange }: Props) {
  return (
    <div
      className="glass-elevated flex items-center gap-2 rounded-2xl p-1 pl-3 shadow-glass-sm"
      role="group"
      aria-label="Método de disparo"
    >
      <span className="hidden text-xs text-muted-foreground sm:inline">Método de disparo</span>
      <Tooltip
        className="max-w-xs"
        content={
          <>
            Define quem pode entrar: <strong>Push</strong> só quem tem o app, <strong>E-mail</strong> quem tem e-mail e{' '}
            <strong>SMS</strong> quem tem telefone. Vale na contagem, na amostra, no público salvo e no assistente de IA.
            Consentimento e descadastro são conferidos no envio da campanha.
          </>
        }
      />
      <SegmentedControl size="sm" value={value} onChange={onChange} options={OPTIONS} />
    </div>
  );
}
